import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ExistingAccountModal from '../components/ActiveExistingAccount/ExistingAccountModal'
import * as actions from '../actions'
 
export const ExistingAccountContainer = ({
  existingAccount = {},
  locationAddress,
  getOrderServices,
  setSessionData,
  fxbuyflowSessionId
}) => {
  const handleCloseModal = useCallback(() => {
    setSessionData({
      existingAccount: {
        ...existingAccount,
        showExistingAccountModal: false
      }
    })
  }, [existingAccount, setSessionData])
 
  if (!existingAccount.showExistingAccountModal) {
    return null
  }
 
  return (
    <ExistingAccountModal
      visible={existingAccount.showExistingAccountModal}
      onCancel={handleCloseModal}
      getOrderServices={getOrderServices}
      fxbuyflowSessionId={fxbuyflowSessionId}
      existingServicesWithBanText={existingAccount.existingServicesWithBan}
      newServicesText={existingAccount.newServicesText}
      locationAddress={locationAddress}
    />
  )
}
 
ExistingAccountContainer.propTypes = {
  existingAccount: PropTypes.shape({
    showExistingAccountModal: PropTypes.bool,
    existingServicesWithBan: PropTypes.string,
    newServicesText: PropTypes.string
  }),
  locationAddress: PropTypes.string,
  getOrderServices: PropTypes.func.isRequired,
  setSessionData: PropTypes.func.isRequired,
  fxbuyflowSessionId: PropTypes.string
}
 
export const mapStateToProps = state => ({
  existingAccount: state.session?.existingAccount,
  locationAddress: state.customer?.details?.site?.name,
  fxbuyflowSessionId: state.session?.fxbuyflowSessionId
})
 
export const mapDispatchToProps = {
  getOrderServices: actions.getOrderServices,
  setSessionData: actions.setSessionData
}
 
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExistingAccountContainer)
